import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-4d301397")
const _hoisted_1 = { class: "splash-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-white" }, "Reset Password", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "lead text-white" }, "To continue resetting your password, please enter your email address and new password.", -1)
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "emailAddress",
  class: "form-label text-white"
}, "Email Address", -1)
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "form-label text-white"
}, "Password", -1)
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "emailAddress",
  class: "form-label text-white"
}, "Confirm Password", -1)
const _hoisted_10 = {
  key: 0,
  class: "text-danger fw-bold text-center"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-ban" }, null, -1)
const _hoisted_12 = { class: "mt-1" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 1,
  class: "text-center"
}
const _hoisted_15 = {
  class: "alert alert-success rounded mt-3",
  role: "alert"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" New password has been set. ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Login with your new password.")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_password_feedback = _resolveComponent("password-feedback")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.model.emailAddress = $event)),
        class: "form-control",
        required: ""
      }, null, 512), [
        [_vModelText, _ctx.model.emailAddress]
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.model.password = $event)),
        class: "form-control",
        type: "password",
        required: ""
      }, null, 512), [
        [_vModelText, _ctx.model.password]
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.model.confirmPassword = $event)),
        class: "form-control",
        type: "password",
        required: ""
      }, null, 512), [
        [_vModelText, _ctx.model.confirmPassword]
      ])
    ]),
    (_ctx.model.errorResponse)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _hoisted_11,
          _createTextVNode(" " + _toDisplayString(_ctx.model.errorResponse), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_component_password_feedback, {
        password: (_ctx.model.password || ''),
        "confirm-password": (_ctx.model.confirmPassword || ''),
        modelValue: _ctx.model.newPasswordIsValid,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.model.newPasswordIsValid = $event))
      }, null, 8, ["password", "confirm-password", "modelValue"]),
      _createElementVNode("p", _hoisted_12, [
        _createElementVNode("button", {
          class: _normalizeClass(["btn", { 'btn-primary': _ctx.model.newPasswordIsValid, 'btn-secondary': !_ctx.model.newPasswordIsValid }]),
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.resetPassword && _ctx.resetPassword(...args))),
          disabled: !_ctx.model.newPasswordIsValid,
          type: "button"
        }, "Reset Password", 10, _hoisted_13)
      ])
    ]),
    (_ctx.model.submitted)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_router_link, { to: "/login" }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}